.addRemoveButton:global(.MuiButton-root) {
	width: 110px;
	height: 100%;
	font-size: 0.9375rem;
	margin-top: 0.125rem;
}

.addTextfield {
	height: 100%;
	flex: 1;

	& :global(.MuiOutlinedInput-root) {
		height: 100%;
	}
}

.textFieldLabelWrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 6px;
	margin: 0 10px;
	width: 100%;
}

.textFieldLabel {
	color: #404040;
	font-size: 14px;
	font-weight: 500;
}

.textFieldRow {
	display: flex;
	flex-direction: row;
	width: 100%;
	align-items: center;
	justify-content: center;
	gap: 0.625rem;
	height: 40px;
}

.cellContainer {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	height: 28px;
	gap: 1rem;
	width: 100%;
}

.textValue:global(.MuiTypography-root) {
	color: #575757;
	font-size: 0.9375rem;
	font-weight: 400;
	line-height: 1.5;
	letter-spacing: 0;

	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.badge:global(.MuiChip-root) {
	display: flex;
	align-items: center;
	padding: 2px 10px;
	border-radius: 4px;
	height: 28px;
	flex-shrink: 0;

	& span {
		color: #344054;
		font-size: 0.9375rem;
		line-height: 1.5;
		font-weight: 500;
		padding: 0;
		flex-shrink: 0;
		white-space: nowrap;
	}
}

.editRow {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.3125rem;
	height: 40px;
	box-sizing: border-box;
	padding: 0.25rem 0;
}

.editRowButton:global(.MuiButton-root) {
	height: 100%;
	width: 87px;
	margin-top: 0.25rem;
}

.editRowTextfield {
	flex: 1;
	height: 100%;
	& :global(.MuiOutlinedInput-root) {
		height: 100%;
		font-size: 0.9375rem;
	}
}

.selectAllContainer {
	padding-right: 0.9375rem;
}

.deleteButton {
	flex-shrink: 0;

	& svg {
		color: #4d2e90;
	}
}

@media (max-width: 768px) {
	.textFieldRow {
		flex-direction: column;
		height: unset;
	}

	.addRemoveButton:global(.MuiButton-root) {
		width: 100%;
		margin-top: unset;
	}

	.editRowButton:global(.MuiButton-root) {
		width: unset;
	}

	.editRow {
		width: 100%;
		align-items: center;
	}

	.editRowTextfield:global(.MuiFormControl-root) {
		flex: unset;
		width: 100%;
		min-width: 100px;
	}
}
